import { PencilIcon } from '@heroicons/react/solid';
import { Button } from '@/components/Elements';
import { FormDrawer, Field } from '@/components/Form';
import { Authorization, ROLES } from '@/lib/authorization';
import { useMutation, useQuery } from 'react-query';
import { useNotificationStore } from '@/stores/notifications';
import { useFormik } from 'formik';
import { createVimeoSchema } from '@/utils/yup';
import { fetchIntro, updateIntro } from './api';

interface FormikState {
  vimeoId: string;
  enabled: boolean;
  title: string;
  buttonText: string;
}

export const UpdateIntro = () => {
  const { addNotification } = useNotificationStore();
  const { data } = useQuery('get-intro', () => fetchIntro());
  const { mutate, isLoading, isSuccess } = useMutation(updateIntro, {
    onSuccess: (message: string) => {
      addNotification({
        type: 'success',
        title: message,
      });
    },
  });

  const formik = useFormik<FormikState>({
    enableReinitialize: true,
    initialValues: {
      vimeoId: data?.vimeoId || '',
      enabled: data?.enabled ?? true,
      title: data?.title || '',
      buttonText: data?.buttonText || '',
    },
    validationSchema: createVimeoSchema,
    onSubmit: (values) => {
      mutate(values);
    },
  });
  return (
    <Authorization allowedRoles={[ROLES.ADMIN]}>
      <FormDrawer
        isDone={isSuccess}
        triggerButton={
          <Button startIcon={<PencilIcon className="h-4 w-4" />} size="sm">
            Update Video
          </Button>
        }
        title="Update Intro Video"
        submitButton={
          <Button form="update-intro" type="submit" size="sm" isLoading={isLoading}>
            Submit
          </Button>
        }
      >
        <form id="update-intro" onSubmit={formik.handleSubmit}>
          <div className="flex items-center justify-between mb-3">
            <label htmlFor="enabled" className="text-sm font-medium text-gray-700">
              Intro Enabled
            </label>
            <button
              type="button"
              onClick={() =>
                formik.setFieldValue('enabled', !formik.values.enabled)
              }
              className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 ${formik.values.enabled
                  ? 'bg-green-500 focus:ring-green-500'
                  : 'bg-gray-300 focus:ring-gray-400'
                }`}
            >
              <span
                className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${formik.values.enabled ? 'translate-x-6' : 'translate-x-1'
                  }`}
              />
            </button>
          </div>
          <Field label="Vimeo ID" formik={formik} name="vimeoId" />
          <Field label="Title" formik={formik} name="title" />
          <Field label="Button Text" formik={formik} name="buttonText" />
        </form>
      </FormDrawer>
    </Authorization>
  );
};
